<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold">پرینت حواله بین انبار</h5>
        <div style="flex:1"></div>
      </div>
      <div class="card-body" id="print">
<div v-for="(page, index) in transferPages" :key="index" :class="{ 'page-break': index !== 0 }">
            <div class="page-header">
            <h4>شناسه حواله: {{ page.items[0].transferId }}</h4>
            <div class="col-7">
              <div class="d-flex justify-content-between">
                <h4>حواله بین انبار از <span class="font-bold">{{ page.items[0].fromStore }}</span> به
                  <span class="font-bold">{{ page.items[0].toStore }}</span>
                </h4>
                <h4>تاریخ: <span>{{ page.items[0].date | persianDate }}</span></h4>
              </div>
            </div>
          </div>
          <table class="table table-responsive-sm table-bordered table-hover styled-table">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>محصول</th>
                <th>SKU</th>
                <th>قیمت</th>
                <th>مقدار انتقال</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in page.items" :key="item.variety.product_sku">
                <td>{{ item.pageNumber }}</td>
                <td>{{ item.variety.title }}</td>
                <td>{{ item.variety.product_sku }}</td>
                <td>{{ item.variety.product_unit_price | price }}</td>
                <td>{{ item.quantity || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card-footer not-in-print" v-if="transferPages.length > 0">
        <div class="d-flex justify-content-center align-items-center">
          <button class="btn btn-purple" onclick="window.print()">چاپ</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      transfers: [],
    };
  },
  mounted() {
    this.loadData(this.$route.query.ids);
  },
  computed: {
    transferCount() {
      const ids = new Set();
      this.transfers.forEach(t => ids.add(t.id));
      return ids.size;
    },

    allItemsWithNumber() {
      let count = 0;
      const items = [];
      this.transfers.forEach(transfer => {
        transfer.items.forEach(item => {
          count++;
          items.push({
            ...item,
            globalNumber: count,
            transferId: transfer.id,
            fromStore: transfer.from_store_label,
            toStore: transfer.to_store_label,
            date: transfer.created_at
          });
        });
      });
      return items;
    },
    transferPages() {
      const pages = [];
      const items = this.allItemsWithNumber;
      let transferRowCounts = {};
      let currentPage = null; 
      let lastTransferId = null;

      items.forEach((item) => {
        if (lastTransferId !== item.transferId) {
          if (currentPage && currentPage.items.length > 0) {
            pages.push(currentPage);
          }
          currentPage = { items: [] };
        }

        if (!transferRowCounts[item.transferId]) {
          transferRowCounts[item.transferId] = 1;
        }

        item.pageNumber = transferRowCounts[item.transferId]++;
        currentPage.items.push(item);
        lastTransferId = item.transferId;
      });

      if (currentPage && currentPage.items.length > 0) {
        pages.push(currentPage);
      }

      return pages;
    }


  },

  methods: {
    async loadData(ids) {
      try {
        const response = await this.$axios.get(`admin/store-transfers/multi-prints?ids=${ids}`);
        console.log(response.data.data);
        this.transfers = response.data.data.transfers;
      } catch (e) {
        this.$root.notify(e);
      }
    },
  }
}  
</script>

<style scoped>
.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-family: Tahoma, Geneva, Verdana, sans-serif;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.styled-table thead {
  background-color: #4CAF50;
  color: white;
}

.styled-table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.styled-table tbody tr:hover {
  background-color: #ddd;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: center;
}

.table-responsive-sm {
  height: auto;
}

@media print {
  thead {
    display: table-row-group;
  }

  .styled-table tbody tr,
  .styled-table th,
  .styled-table td {
    page-break-inside: avoid;
  }

  .page-break {
  break-before: page;
}



  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>